export default "__VITE_ASSET__BsQj9_Xx__"